import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface Props {
  open: boolean;
  itemsCount: number;
  branchName: string;
  onKeepCurrent: () => void;
  onSwitch: () => void;
}

export default function ChangeConfirmDialog({ open, itemsCount, branchName, onKeepCurrent, onSwitch }: Props) {
  const { t,language } = useLanguage();
  const isRTL = language === "ar";

  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onKeepCurrent()}>
      <AlertDialogContent dir={isRTL ? "rtl" : "ltr"}>
        <AlertDialogHeader>
          <AlertDialogTitle className={isRTL ? "text-right" : "text-left"}>{t("branch.changeWillClear")}</AlertDialogTitle>
          <AlertDialogDescription className={isRTL ? "text-right" : "text-left"}>
            {t("branch.itemsInCart").replace("{count}", String(itemsCount)).replace("{branch}", branchName)}
            <span className="block mt-1">{t("branch.switchingWillClear")}</span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className={isRTL ? "sm:justify-start gap-2" : "sm:justify-end gap-2"}>
          <Button variant="outline" onClick={onKeepCurrent}>
            {t("branch.keepCurrent")}
          </Button>
          <Button variant="destructive" onClick={onSwitch}>
            {t("branch.switchClear")}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
